function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome4C({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272,
    height: 416,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#77c69b",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1F9A2",
    d: "m75.957.941 94.419 321.108L0 319.517 75.957.941Z",
    style: {
      fill: "#77c69b",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#518d64",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#64E986",
    d: "M76.193 302.031c.792-7.983 6.024-15.965 13.87-17.625 11.177-2.371 20.767 8.457 25.364 18.89 4.677 10.432 8.085 22.604 17.914 28.453-9.195-24.344-14.743-50.03-16.487-75.954-.713-10.433-.238-22.131 7.134-29.481 12.206-12.013 34.796-2.371 41.375 13.436 6.578 15.808 2.298 33.749-2.14 50.267-1.031-31.456 6.341-63.15 21.163-90.891 3.249-6.007 6.975-12.093 12.682-15.887 5.706-3.794 13.87-4.663 19.26-.395 6.738 5.374 6.262 15.57 4.597 24.027-4.914 24.897-14.425 48.924-27.821 70.422 9.353-15.255 19.657-31.457 36.144-38.491 16.487-7.034 40.345.632 42.564 18.415 1.823 13.911-9.908 25.924-21.956 33.196-12.048 7.271-25.998 12.724-34.241 24.106 14.901-9.169 36.064-17.704 47.954-4.822 11.73 12.646 1.268 33.749-12.762 43.866-20.37 14.7-47.081 18.731-66.976 33.985-6.49 4.975-20.608 28.452-20.608 28.452h-30.147s-12.371-29.794-15.746-35.091c-14.426-22.92-43.99-49.081-41.137-78.878Z",
    style: {
      fill: "#518d64",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome4C);
export default __webpack_public_path__ + "static/media/bg_home4_c.8d2a2ff6f8f44e5afb0224d18f8cf410.svg";
export { ForwardRef as ReactComponent };